import { mutatorAction } from "satcheljs";
import { getConditionalFormattingStore } from "../store/store";
import type { MailboxInfo } from "owa-client-types";
import type { ConditionalFormattingModification } from "../store/schema/ConditionalFormattingRule";
import type { ConditionalFormattingScenario } from "../store/schema/ConditionalFormattingScenarioType";

const addEntryToRowToModificationMapMutator: (key: string, modifications: ConditionalFormattingModification[], mailboxInfo: MailboxInfo, scenario: ConditionalFormattingScenario) => void = mutatorAction("addEntryToRowToModificationMap", function addEntryToRowToModificationMap(key: string, modifications: ConditionalFormattingModification[], mailboxInfo: MailboxInfo, scenario: ConditionalFormattingScenario): void {
    getConditionalFormattingStore(mailboxInfo, scenario).rowToModificationsMap.set(key, modifications);
});
export default addEntryToRowToModificationMapMutator;
